import React, { useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import {
  CardContent,
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";

function AssetAgeing({ responseFem, responseBem }) {
  const navigate = useNavigate();

  const [selectedType, setSelectedType] = useState("FEMS");

  // Function to handle radio group change
  const handleRadioChange = (event) => {
    setSelectedType(event.target.value);
  };

  // Dynamically set pie chart data based on the selected radio value
  const pieData =
    selectedType === "FEMS"
      ? [
        {
          id: 0,
          value: responseFem.assetLessThanFiveYears,
          label: `<5 Years(${responseFem.assetLessThanFiveYears})`,
          color: "#4CAF50",
        },
        {
          id: 1,
          value: responseFem.assetFiveToTenYears,
          label: `5 to 10 years(${responseFem.assetFiveToTenYears})`,
          color: "#62B5DD",
        },
        {
          id: 2,
          value: responseFem.assetElevenToFourteenYears,
          label: `11 to 14 years(${responseFem.assetElevenToFourteenYears})`,
          color: "#FF9800",
        },
        {
          id: 3,
          value: responseFem.assetGreaterThanFifteenYears,
          label: `>15 years(${responseFem.assetGreaterThanFifteenYears})`,
          color: "#A77BCA",
        },
      ]
      : [
        {
          id: 0,
          value: responseBem.assetLessThanFiveYears,
          label: `<5 Years(${responseBem.assetLessThanFiveYears})`,
          color: "#4CAF50",
        },
        {
          id: 1,
          value: responseBem.assetFiveToTenYears,
          label: `5 to 10 years(${responseBem.assetFiveToTenYears})`,
          color: "#62B5DD",
        },
        {
          id: 2,
          value: responseBem.assetElevenToFourteenYears,
          label: `11 to 14 years(${responseBem.assetElevenToFourteenYears})`,
          color: "#FF9800",
        },
        {
          id: 3,
          value: responseBem.assetGreaterThanFifteenYears,
          label: `>15 years(${responseBem.assetGreaterThanFifteenYears})`,
          color: "#A77BCA",
        },
      ];

  return (
    <StyledCard variant="outlined">
      <CardContent>
        <Typography
          mb={1.5}
          variant="h5"
          fontWeight={700}
          color={"text.primary"}
        >
          Asset Ageing Overview
        </Typography>
        <Box>
          <RadioGroup
            row
            aria-labelledby="work-order-chart"
            name="work-order-chart"
            value={selectedType}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value="FEMS"
              control={<Radio size="small" />}
              label="FEMS"
            />
            <FormControlLabel
              value="BEMS"
              control={<Radio size="small" />}
              label="BEMS"
            />
          </RadioGroup>
        </Box>
        <Box width={"100%"}>
          <PieChart
            series={[{ data: pieData }]}
            height={300}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "middle" },
                padding: 10,
                itemMarkWidth: 14,  // Make this slightly larger to match font size 12
                itemMarkHeight: 14, // Same as above
                markGap: 8,         // Space between mark and label
                itemGap: 30,        // Space between items
                labelStyle: {
                  fontSize: 11,               // Keep font size 12 as you need
                  color: "text.primary",
                  fontWeight: 400,
                  lineHeight: "16px",         // Important: add lineHeight to center-align better
                  display: "flex",            // Optional: ensures alignment consistency
                  alignItems: "center",       // Optional: aligns icon and text properly
                },
              },
            }}
            margin={{
              left: 60,
              bottom: 50,
              top: 50,
            }}
            onItemClick={(event, item) => {
              const route = selectedType === "FEMS" ? "/assetsFEM" : "/assetsBEM";
              navigate(route, { state: { selectedType } });
            }}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
}

export default AssetAgeing;
